import { describeRescheduleAntecedence } from '@src/domains/sale-items';
import type { Translate } from '@src/i18n/useTranslate';

/** Product's reschedule antecedence in minutes. */
export const formatRescheduleAntecedence = (totalMinutes: number, i18n: Translate['i18n']): string => {
  const { days, hours, minutes } = describeRescheduleAntecedence(totalMinutes);

  if (!days && !hours && !minutes) {
    return i18n('reschedule_minutes', { count: totalMinutes });
  }

  const parts: string[] = [];

  if (days) parts.push(i18n('reschedule_days', { count: days }));
  if (hours) parts.push(i18n('reschedule_hours', { count: hours }));
  if (minutes) parts.push(i18n('reschedule_minutes', { count: minutes }));

  return parts.join(' ');
};
